import React, { createContext, useState, useEffect, useContext } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("authToken") || null);
  const [username, setUsername] = useState(
    localStorage.getItem("username") || "",
  );

  useEffect(() => {
    if (token) {
      localStorage.setItem("authToken", token);
      localStorage.setItem("username", username);
    } else {
      localStorage.removeItem("authToken");
      localStorage.removeItem("username");
    }
  }, [token, username]);

  const login = (newToken, newUsername) => {
    setToken(newToken);
    setUsername(newUsername);
  };

  const logout = () => {
    setToken(null);
    setUsername("");
  };

  return (
    <AuthContext.Provider value={{ token, username, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
// export const AuthProvider = ({ children }) => {
//   const [token, setToken] = useState(localStorage.getItem("authToken") || null);

//   const [username, setUsername] = useState(
//     localStorage.getItem("username") || "",
//   );

//   useEffect(() => {
//     if (token) {
//       localStorage.setItem("authToken", token);
//       localStorage.setItem("username", username);
//     } else {
//       localStorage.removeItem("authToken");
//       localStorage.removeItem("username");
//     }
//   }, [token, username]);

//   /* 🔥 FIXED LOGIN FUNCTION */
//   const login = ({ token, userID }) => {
//     setToken(token);
//     setUsername(userID);
//   };

//   const logout = () => {
//     setToken(null);
//     setUsername("");
//   };

//   return (
//     <AuthContext.Provider value={{ token, username, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const AuthProvider = ({ children }) => {
//   const [token, setToken] = useState(localStorage.getItem("authToken") || null);

//   const [username, setUsername] = useState(
//     localStorage.getItem("username") || "",
//   );

//   useEffect(() => {
//     if (token) {
//       localStorage.setItem("authToken", token);
//       localStorage.setItem("username", username);
//     } else {
//       localStorage.removeItem("authToken");
//       localStorage.removeItem("username");
//     }
//   }, [token, username]);

//   /* 🔥 FIXED LOGIN FUNCTION */
//   const login = ({ token, userID }) => {
//     setToken(token);
//     setUsername(userID);
//   };

//   const logout = () => {
//     setToken(null);
//     setUsername("");
//   };

//   // 🔥 NEW: Decode JWT
//   const parseJwt = (token) => {
//     try {
//       return JSON.parse(atob(token.split(".")[1]));
//     } catch {
//       return null;
//     }
//   };

//   // 🔥 NEW: Auto logout on expiry
//   useEffect(() => {
//     if (!token) return;

//     const decoded = parseJwt(token);

//     if (!decoded?.exp) {
//       logout();
//       return;
//     }

//     const expiryTime = decoded.exp * 1000;
//     const remainingTime = expiryTime - Date.now();

//     if (remainingTime <= 0) {
//       logout(); // already expired
//     } else {
//       const timer = setTimeout(() => {
//         logout(); // 🔥 logout exactly at expiry
//       }, remainingTime);

//       return () => clearTimeout(timer);
//     }
//   }, [token]);

//   return (
//     <AuthContext.Provider value={{ token, username, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const AuthProvider = ({ children }) => {
//   const [token, setToken] = useState(localStorage.getItem("authToken") || null);
//   console.log("tokemn", token);

//   // 🔥 READ FROM authUser (YOUR SOURCE OF TRUTH)
//   const storedUser = localStorage.getItem("authUser");
//   const parsedUser = storedUser ? JSON.parse(storedUser) : null;
//   const actualToken = parsedUser?.token; // ✅ IMPORTANT

//   const [username, setUsername] = useState(
//     localStorage.getItem("username") || "",
//   );

//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUser");

//     if (storedUser) {
//       const parsed = JSON.parse(storedUser);

//       if (parsed?.token && parsed.token !== token) {
//         console.log("🔥 Syncing token from authUser → state");
//         setToken(parsed.token);
//       }
//     }
//   }, []);
//   // const t = JSON.parse(localStorage.getItem("authUser"))?.token;
//   // const payload = JSON.parse(atob(t?.split(".")[1]));

//   // console.log("EXP:", payload.exp);
//   // console.log("NOW:", Date.now() / 1000);
//   // console.log("DIFF(sec):", payload.exp - Date.now() / 1000);
//   useEffect(() => {
//     if (token) {
//       console.log("🔥 DEBUG: Saving token to localStorage");
//       localStorage.setItem("authToken", token);
//       localStorage.setItem("username", username);
//     } else {
//       console.log("🔥 DEBUG: Clearing localStorage (logout)");
//       localStorage.removeItem("authToken");
//       localStorage.removeItem("username");
//     }
//   }, [token, username]);

//   /* 🔥 LOGIN */
//   const login = ({ token, userID }) => {
//     console.log("🔥 DEBUG: LOGIN CALLED", { token, userID });

//     // ✅ store full object (your current system)
//     localStorage.setItem("authUser", JSON.stringify({ token, userID }));

//     setToken(token);
//     setUsername(userID);
//   };

//   const logout = () => {
//     console.log("🔥 DEBUG: LOGOUT CALLED");

//     localStorage.removeItem("authUser"); // ✅ IMPORTANT

//     setToken(null);
//     setUsername("");
//   };

//   // 🔥 Decode JWT
//   const parseJwt = (token) => {
//     try {
//       const decoded = JSON.parse(atob(token.split(".")[1]));
//       console.log("🔥 DEBUG: DECODED TOKEN:", decoded);
//       return decoded;
//     } catch (err) {
//       console.log("🔥 DEBUG: TOKEN PARSE FAILED");
//       return null;
//     }
//   };

//   // 🔥 AUTO LOGOUT (FIXED TO USE actualToken)
//   // useEffect(() => {
//   //   if (!token) {
//   //     console.log("🔥 DEBUG: No token, skipping expiry check");
//   //     return;
//   //   }

//   //   console.log("🔥 DEBUG: Checking token expiry...");

//   //   const decoded = parseJwt(token);

//   //   if (!decoded?.exp) {
//   //     console.log("🔥 DEBUG: No exp found → logout");
//   //     logout();
//   //     return;
//   //   }

//   //   const expiryTime = decoded.exp * 1000;
//   //   const currentTime = Date.now();
//   //   const remainingTime = expiryTime - currentTime;

//   //   console.log("🔥 DEBUG: Expiry Time:", new Date(expiryTime));
//   //   console.log("🔥 DEBUG: Current Time:", new Date(currentTime));
//   //   console.log("🔥 DEBUG: Remaining ms:", remainingTime);

//   //   // if (remainingTime <= 0) {
//   //   //   console.log("🔥 DEBUG: Token already expired → logout");
//   //   //   logout();
//   //   // } else {
//   //   //   console.log("🔥 DEBUG: Setting logout timer for:", remainingTime, "ms");

//   //   //   const timer = setTimeout(() => {
//   //   //     console.log("🔥 DEBUG: TIMER FIRED → LOGOUT");
//   //   //     logout();
//   //   //   }, remainingTime);

//   //   //   return () => {
//   //   //     console.log("🔥 DEBUG: Clearing previous timer");
//   //   //     clearTimeout(timer);
//   //   //   };
//   //   // }
//   //   if (remainingTime <= 2000) {
//   //     // 🔥 if less than 2 sec → logout immediately
//   //     console.log("🔥 DEBUG: Expiring soon → immediate logout");
//   //     logout();
//   //   } else {
//   //     const timer = setTimeout(() => {
//   //       console.log("🔥 DEBUG: TIMER FIRED → LOGOUT");
//   //       logout();
//   //     }, remainingTime);

//   //     return () => clearTimeout(timer);
//   //   }
//   // }, [token]);
//   useEffect(() => {
//     if (!token) {
//       console.log("🔥 DEBUG: No token, skipping expiry check");
//       return;
//     }

//     console.log("🔥 DEBUG: Checking token expiry...");

//     const decoded = parseJwt(token);

//     if (!decoded?.exp) {
//       console.log("🔥 DEBUG: No exp found → logout");
//       logout();
//       return;
//     }

//     const expiryTime = decoded.exp * 1000;
//     const remainingTime = expiryTime - Date.now();

//     console.log("🔥 DEBUG: Remaining ms:", remainingTime);

//     if (remainingTime <= 2000) {
//       console.log("🔥 DEBUG: Expiring soon → immediate logout");
//       logout();
//     } else {
//       const timer = setTimeout(() => {
//         console.log("🔥 DEBUG: TIMER FIRED → LOGOUT");
//         logout();
//       }, remainingTime);

//       return () => clearTimeout(timer);
//     }
//   }, [token]); // ✅ IMPORTANT
//   useEffect(() => {
//     if (!token) return;

//     const interval = setInterval(() => {
//       const decoded = parseJwt(token);

//       if (!decoded?.exp) {
//         logout();
//         return;
//       }

//       const expiryTime = decoded.exp * 1000;

//       if (Date.now() >= expiryTime) {
//         console.log("🔥 INTERVAL: Token expired → logout");
//         logout();
//       }
//     }, 1000); // check every 1 second

//     return () => clearInterval(interval);
//   }, [token]);
//   return (
//     <AuthContext.Provider value={{ token, username, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const AuthProvider = ({ children }) => {
//   // ✅ FIX: initialize token from authUser (NOT authToken)
//   const [token, setToken] = useState(() => {
//     const storedUser = localStorage.getItem("authUser");
//     return storedUser ? JSON.parse(storedUser).token : null;
//   });

//   console.log("token", token);

//   const [username, setUsername] = useState(
//     localStorage.getItem("username") || "",
//   );

//   // ✅ SYNC authUser ↔ state (handles logout without refresh)
//   useEffect(() => {
//     const interval = setInterval(() => {
//       const storedUser = localStorage.getItem("authUser");

//       if (!storedUser) return;

//       const parsed = JSON.parse(storedUser);
//       const currentToken = parsed?.token;

//       if (!currentToken) return;

//       const decoded = parseJwt(currentToken);

//       if (!decoded?.exp) {
//         logout();
//         return;
//       }

//       const expiryTime = decoded.exp * 1000;

//       if (Date.now() >= expiryTime) {
//         console.log("🔥 INTERVAL FORCE LOGOUT");
//         logout();
//       }
//     }, 1000);

//     return () => clearInterval(interval);
//   }, []); // ✅ IMPORTANT: empty dependency

//   // 🔥 EXISTING (kept)
//   useEffect(() => {
//     if (token) {
//       console.log("🔥 DEBUG: Saving username");
//       localStorage.setItem("username", username);
//     } else {
//       console.log("🔥 DEBUG: Clearing localStorage (logout)");
//       localStorage.removeItem("username");
//     }
//   }, [token, username]);

//   /* 🔥 LOGIN */
//   const login = ({ token, userID }) => {
//     console.log("🔥 DEBUG: LOGIN CALLED", { token, userID });

//     localStorage.setItem("authUser", JSON.stringify({ token, userID }));

//     setToken(token);
//     setUsername(userID);
//   };

//   const logout = () => {
//     console.log("🔥 DEBUG: LOGOUT CALLED");

//     localStorage.removeItem("authUser");

//     setToken(null);
//     setUsername("");
//   };

//   // 🔥 Decode JWT
//   const parseJwt = (token) => {
//     try {
//       const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");

//       return JSON.parse(atob(base64));
//     } catch {
//       return null;
//     }
//   };

//   // ✅ AUTO LOGOUT TIMER
//   useEffect(() => {
//     if (!token) return;

//     const decoded = parseJwt(token);

//     if (!decoded?.exp) {
//       logout();
//       return;
//     }

//     const expiryTime = decoded.exp * 1000;
//     const remainingTime = expiryTime - Date.now();

//     console.log("🔥 Remaining ms:", remainingTime);

//     if (remainingTime <= 2000) {
//       logout();
//     } else {
//       const timer = setTimeout(() => {
//         console.log("🔥 TIMER FIRED → LOGOUT");
//         logout();
//       }, remainingTime);

//       return () => clearTimeout(timer);
//     }
//   }, [token]);

//   // ✅ INTERVAL BACKUP (handles navigation cases)
//   useEffect(() => {
//     if (!token) return;

//     const interval = setInterval(() => {
//       const decoded = parseJwt(token);

//       if (!decoded?.exp) {
//         logout();
//         return;
//       }

//       const expiryTime = decoded.exp * 1000;

//       if (Date.now() >= expiryTime) {
//         console.log("🔥 INTERVAL → LOGOUT");
//         logout();
//       }
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [token]);

//   return (
//     <AuthContext.Provider value={{ token, username, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };
export const useNewAuth = () => useContext(AuthContext);
